module.exports = __webpack_public_path__ + "img/map-marker-icon-blue.296ddd80.png";